/* ============================================================
   MIRELLE & CO — Global JavaScript
   sst-script.js
   ============================================================ */

(function () {
  'use strict';

  /* ---- Scroll-reveal (IntersectionObserver) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.sst-reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('sst-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header: add .scrolled class on scroll ---- */
  function initHeader() {
    var header = document.querySelector('.sst-header');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('sst-scrolled', window.scrollY > 30);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Announcement bar rotation ---- */
  function initAnnounce() {
    var items = document.querySelectorAll('.sst-announce-item');
    if (items.length <= 1) return;
    var current = 0;
    items.forEach(function (el, i) {
      el.classList.toggle('sst-announce-visible', i === 0);
    });
    setInterval(function () {
      items[current].classList.remove('sst-announce-visible');
      current = (current + 1) % items.length;
      items[current].classList.add('sst-announce-visible');
    }, 4000);
  }

  /* ---- Mobile menu toggle ---- */
  function initMobileMenu() {
    var openBtn  = document.querySelector('[data-sst-menu-open]');
    var closeBtn = document.querySelector('[data-sst-menu-close]');
    var menu     = document.querySelector('.sst-mmenu');
    var overlay  = document.querySelector('.sst-overlay');
    if (!openBtn || !menu) return;

    function open() {
      menu.classList.add('sst-open');
      if (overlay) overlay.classList.add('sst-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      menu.classList.remove('sst-open');
      if (overlay) overlay.classList.remove('sst-open');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* Sub-menu accordions */
    menu.addEventListener('click', function (e) {
      var btn = e.target.closest('.sst-mmenu-acc-btn');
      if (!btn) return;
      var item = btn.closest('.sst-mmenu-item');
      var subList = item && item.querySelector('.sst-mmenu-sub-list');
      if (!item || !subList) return;
      var isOpen = item.classList.contains('sst-open');
      /* close all others */
      menu.querySelectorAll('.sst-mmenu-item.sst-open').forEach(function (el) {
        el.classList.remove('sst-open');
        var sl = el.querySelector('.sst-mmenu-sub-list');
        if (sl) sl.setAttribute('aria-hidden', 'true');
        var ab = el.querySelector('.sst-mmenu-acc-btn');
        if (ab) ab.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('sst-open');
        subList.setAttribute('aria-hidden', 'false');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---- Search overlay toggle ---- */
  function initSearch() {
    var openBtns  = document.querySelectorAll('[data-sst-search-open]');
    var closeBtns = document.querySelectorAll('[data-sst-search-close]');
    var wrap      = document.querySelector('.sst-search-wrap');
    var backdrop  = document.getElementById('sst-search-backdrop');
    if (!wrap || !openBtns.length) return;

    function open() {
      wrap.classList.add('sst-open');
      wrap.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('sst-open');
      document.body.style.overflow = 'hidden';
      var input = wrap.querySelector('input[name="q"]');
      if (input) setTimeout(function () { input.focus(); }, 350);
    }
    function close() {
      wrap.classList.remove('sst-open');
      wrap.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('sst-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Megamenu hover (desktop) ---- */
  function initMegamenu() {
    var header   = document.querySelector('.sst-header');
    var triggers = document.querySelectorAll('[data-sst-mega]');
    var menus    = [];
    triggers.forEach(function (trigger) {
      var id   = trigger.dataset.sstMega;
      var menu = document.getElementById(id);
      if (!menu) return;
      menus.push(menu);
      var timer;
      function show() {
        clearTimeout(timer);
        menus.forEach(function (m) { m.classList.remove('sst-open'); });
        menu.classList.add('sst-open');
      }
      function hide() { timer = setTimeout(function () { menu.classList.remove('sst-open'); }, 120); }
      trigger.addEventListener('mouseenter', show);
      trigger.addEventListener('mouseleave', hide);
      menu.addEventListener('mouseenter', show);
      menu.addEventListener('mouseleave', hide);
    });
    if (header) {
      header.addEventListener('mouseleave', function () {
        menus.forEach(function (m) { m.classList.remove('sst-open'); });
      });
    }
  }

  /* ---- Cart drawer open/close (works alongside Dawn cart-drawer.js) ---- */
  function setSSTCartCount(count) {
    var value = Math.max(parseInt(count, 10) || 0, 0);
    document.querySelectorAll('.sst-cart-count').forEach(function (badge) {
      badge.textContent = value;
      badge.setAttribute('aria-label', value + (value === 1 ? ' item' : ' items'));
      badge.classList.toggle('sst-cart-count--empty', value === 0);
    });

    document.querySelectorAll('.sst-cart-icon').forEach(function (link) {
      link.setAttribute('aria-label', 'Cart (' + value + (value === 1 ? ' item' : ' items') + ')');
    });
  }

  function syncSSTCartCount(cartData) {
    if (cartData && typeof cartData.item_count === 'number') {
      setSSTCartCount(cartData.item_count);
      return;
    }

    fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setSSTCartCount(cart.item_count); })
      .catch(function () {});
  }

  function initSSTCartCount() {
    syncSSTCartCount();

    // pubsub.js / constants.js are deferred *after* this script, so `subscribe`
    // and PUB_SUB_EVENTS may not exist yet when init() runs. Retry until they do
    // so the badge subscribes to every cart change (add on PDP, remove, clear).
    var attempts = 0;
    (function bindCartUpdate() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          syncSSTCartCount(event && event.cartData);
        });
        return;
      }
      if (attempts++ < 50) setTimeout(bindCartUpdate, 100);
    })();
  }

  function initCartDrawer() {
    var openBtns = document.querySelectorAll('[data-sst-cart-open]');
    var closeBtn = document.querySelector('[data-sst-cart-close]');
    var drawer   = document.querySelector('.sst-cart-drawer');
    var overlay  = document.querySelector('.sst-overlay');
    if (!openBtns.length) return;

    function openDawnCart(trigger) {
      var dawnDrawer = document.querySelector('cart-drawer');
      if (!dawnDrawer || typeof dawnDrawer.open !== 'function') return false;
      dawnDrawer.open(trigger);
      return true;
    }

    function open() {
      if (openDawnCart()) return;
      if (!drawer) return;
      drawer.classList.add('sst-open');
      if (overlay) overlay.classList.add('sst-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('sst-open');
      if (overlay) overlay.classList.remove('sst-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      if (btn.dataset.sstCartReady === 'true') return;
      btn.dataset.sstCartReady = 'true';
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        if (openDawnCart(btn)) return;
        if (drawer) {
          open();
          return;
        }
        window.location.href = btn.href;
      });
      btn.addEventListener('keydown', function (event) {
        if (event.code && event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          if (openDawnCart(btn)) return;
          if (drawer) open();
        }
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---- Product tabs (featured products section) ---- */
  function initProductTabs() {
    document.querySelectorAll('.sst-feat-tabs').forEach(function (tabGroup) {
      var tabs   = tabGroup.querySelectorAll('.sst-feat-tab');
      var panels = tabGroup.closest('.sst-feat-section')
        ? tabGroup.closest('.sst-feat-section').querySelectorAll('.sst-feat-panel')
        : [];

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('sst-active'); });
          tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
          tab.classList.add('sst-active');
          tab.setAttribute('aria-selected', 'true');
          panels.forEach(function (p, j) { p.hidden = j !== i; });
        });
      });
    });
  }

  /* ---- Accordion ---- */
  function initAccordions() {
    document.querySelectorAll('.sst-acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('.sst-acc-item');
        if (!item) return;
        var isOpen = item.classList.contains('sst-open');
        item.classList.toggle('sst-open', !isOpen);
        var body = item.querySelector('.sst-acc-body');
        if (body) body.style.maxHeight = isOpen ? '' : body.scrollHeight + 'px';
      });
    });
  }

  /* ---- Footer mobile column toggles ---- */
  function initFooterToggles() {
    document.querySelectorAll('.sst-footer-col-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var col = btn.closest('.sst-footer-col');
        if (col) col.classList.toggle('sst-open');
      });
    });
  }

  /* ---- WhatsApp widget ---- */
  function initWhatsApp() {
    var btn   = document.querySelector('[data-sst-wa-toggle]');
    var panel = document.querySelector('.sst-wa-panel');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () { panel.classList.toggle('sst-open'); });
  }

  /* ---- Product image gallery (PDP) ---- */
  function initGallery() {
    var thumbs = document.querySelectorAll('.sst-gallery-thumb');
    var hero   = document.querySelector('.sst-gallery-hero-img');
    if (!thumbs.length || !hero) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src    = thumb.dataset.src;
        var srcset = thumb.dataset.srcset || '';
        if (src) hero.src = src;
        if (srcset) hero.srcset = srcset;
        thumbs.forEach(function (t) { t.classList.remove('sst-active'); });
        thumb.classList.add('sst-active');
      });
    });
  }

  /* ---- Sticky add-to-cart bar (PDP) ---- */
  function initStickyBar() {
    var bar    = document.querySelector('.sst-sticky-bar');
    var target = document.querySelector('.sst-atc-trigger');
    if (!bar || !target) return;
    var io = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('sst-show', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(target);
  }

  /* ---- Collection price range: sync styled sliders to Dawn facet inputs ---- */
  function initCollectionPriceRanges(root) {
    var scope = root || document;
    if (!window.__sstPriceRangeDelegated) {
      document.addEventListener('input', function (event) {
        var range = event.target.closest('[data-sst-price-min], [data-sst-price-max]');
        if (!range) return;
        syncCollectionPriceRange(range);
      });
      window.__sstPriceRangeDelegated = true;
    }

    scope.querySelectorAll('[data-sst-price-range]').forEach(function (wrap) {
      if (wrap.dataset.sstReady === 'true') return;
      var minRange = wrap.querySelector('[data-sst-price-min]');
      var maxRange = wrap.querySelector('[data-sst-price-max]');
      var priceRange = wrap.closest('price-range');
      if (!minRange || !maxRange || !priceRange) return;

      var textInputs = priceRange.querySelectorAll('.field__input');
      var minText = textInputs[0];
      var maxText = textInputs[1];
      if (!minText || !maxText) return;

      function paint() {
        var min = sstNumberValue(minRange.min, 0);
        var max = sstNumberValue(maxRange.max, 0);
        var low = sstNumberValue(minRange.value, min);
        var high = sstNumberValue(maxRange.value, max);
        var span = Math.max(max - min, 1);
        var left = ((low - min) / span) * 100;
        var right = 100 - (((high - min) / span) * 100);
        wrap.style.setProperty('--sst-price-left', left + '%');
        wrap.style.setProperty('--sst-price-right', right + '%');
      }

      paint();
      wrap.dataset.sstReady = 'true';
    });
  }

  function observeCollectionFilters() {
    var filters = document.getElementById('main-collection-filters');
    if (!filters || filters.dataset.sstObserved === 'true') return;
    var observer = new MutationObserver(function () {
      initCollectionPriceRanges(filters);
    });
    observer.observe(filters, { childList: true, subtree: true });
    filters.dataset.sstObserved = 'true';
  }

  function sstNumberValue(value, fallback) {
    var n = parseFloat(String(value || '').replace(/,/g, ''));
    return Number.isFinite(n) ? n : fallback;
  }

  function syncCollectionPriceRange(changed) {
    var wrap = changed.closest('[data-sst-price-range]');
    var minRange = wrap && wrap.querySelector('[data-sst-price-min]');
    var maxRange = wrap && wrap.querySelector('[data-sst-price-max]');
    var priceRange = wrap && wrap.closest('price-range');
    if (!wrap || !minRange || !maxRange || !priceRange) return;

    var textInputs = priceRange.querySelectorAll('.field__input');
    var minText = textInputs[0];
    var maxText = textInputs[1];
    if (!minText || !maxText) return;

    var low = sstNumberValue(minRange.value, 0);
    var high = sstNumberValue(maxRange.value, sstNumberValue(maxRange.max, 0));

    if (low > high) {
      if (changed === minRange) {
        high = low;
        maxRange.value = high;
      } else {
        low = high;
        minRange.value = low;
      }
    }

    var min = sstNumberValue(minRange.min, 0);
    var max = sstNumberValue(maxRange.max, 0);
    var span = Math.max(max - min, 1);
    wrap.style.setProperty('--sst-price-left', (((low - min) / span) * 100) + '%');
    wrap.style.setProperty('--sst-price-right', (100 - (((high - min) / span) * 100)) + '%');

    minText.value = low > min ? String(Math.round(low)) : '';
    maxText.value = high < max ? String(Math.round(high)) : '';
    minText.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---- Toast notification helper (global) ---- */
  window.SSTToast = {
    show: function (msg) {
      var wrap = document.querySelector('.sst-toast-wrap');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'sst-toast-wrap';
        document.body.appendChild(wrap);
      }
      var toast = document.createElement('div');
      toast.className = 'sst-toast';
      toast.textContent = msg;
      wrap.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add('sst-toast--in'); });
      setTimeout(function () {
        toast.classList.remove('sst-toast--in');
        setTimeout(function () { toast.remove(); }, 300);
      }, 3000);
    }
  };

  /* ---- Quick-add to cart — opens Dawn cart drawer ---- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sst-quick-add]');
      if (!btn || btn.disabled) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            btn.textContent = original;
            btn.disabled = false;
            window.SSTToast && window.SSTToast.show(data.description || 'Could not add item.');
            return;
          }

          btn.textContent = '✓';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1400);

          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data);
          } else if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
          syncSSTCartCount(data);
        })
        .catch(function () {
          btn.textContent = original;
          btn.disabled = false;
          window.SSTToast && window.SSTToast.show('Error adding to cart.');
        });
    });
  }

  /* ---- Product card carousel ---- */
  function initCarousels() {
    document.querySelectorAll('.sst-feat-carousel-wrap').forEach(function (wrap) {
      var track   = wrap.querySelector('[data-sst-carousel-track]');
      var prevBtn = wrap.querySelector('[data-sst-prev]');
      var nextBtn = wrap.querySelector('[data-sst-next]');
      if (!track) return;

      var slides    = track.querySelectorAll('.sst-feat-carousel-slide');
      var current   = 0;
      var perView   = 4;

      function getPerView() {
        if (window.innerWidth <= 680) return 2;
        if (window.innerWidth <= 900) return 3;
        return 4;
      }

      function slideWidth() {
        return slides[0] ? slides[0].offsetWidth : 0;
      }

      function gap() {
        var style = window.getComputedStyle(track);
        return parseFloat(style.columnGap) || 0;
      }

      function maxIndex() {
        return Math.max(0, slides.length - getPerView());
      }

      function update() {
        var offset = current * (slideWidth() + gap());
        track.style.transform = 'translateX(-' + offset + 'px)';
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current >= maxIndex();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        if (current > 0) { current--; update(); }
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (current < maxIndex()) { current++; update(); }
      });

      window.addEventListener('resize', function () {
        current = Math.min(current, maxIndex());
        update();
      }, { passive: true });

      update();
    });
  }

  /* ---- Init all on DOMContentLoaded ---- */
  function init() {
    initReveal();
    initHeader();
    initAnnounce();
    initMobileMenu();
    initSearch();
    initMegamenu();
    initCartDrawer();
    initSSTCartCount();
    initQuickAdd();
    initCarousels();
    initProductTabs();
    initAccordions();
    initFooterToggles();
    initWhatsApp();
    initGallery();
    initStickyBar();
    initCollectionPriceRanges();
    observeCollectionFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCollectionPriceRanges(event.target);
  });
})();
